// extracted by css-extract-rspack-plugin
module.exports =  {"root":"RadialProgress__root___hxBQK","svg":"RadialProgress__svg___NvSzH","circle":"RadialProgress__circle___jFIbu","path":"RadialProgress__path___x4TQ3"};